import * as React from 'react'
import { useDay, START_DATE, END_DATE } from '@datepicker-react/hooks'
import DatepickerContext from '../configurations/date.range.context'
import cx from 'classnames'
import * as styles from '../date.pickers.styl'
import { createDateFromString, formatDateTime } from '@src/utils/date.helpers'

export interface DayProps {
  day: string
  date: Date
}

const Day: React.FC<DayProps> = ({ day, date }: DayProps) => {
  const dayRef = React.useRef(null)
  const {
    startDate,
    endDate,
    focusedInput,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  } = React.useContext(DatepickerContext)

  function overrideDateSelect(date: Date) {
    const dateFormat = 'yyyy-MM-dd'
    const timeFormat = 'HH:mm'
    const dateTimeFormat = `${dateFormat} ${timeFormat}`

    const newDate = formatDateTime(date, dateFormat)
    if (focusedInput === START_DATE) {
      const time = formatDateTime(startDate || date, timeFormat) || ''
      const dt = formatDateTime(`${newDate} ${time}`, dateTimeFormat)
      date = createDateFromString(dt, dateTimeFormat)
    }
    if (focusedInput === END_DATE) {
      const time = formatDateTime(endDate || date, timeFormat) || ''
      const dt = formatDateTime(`${newDate} ${time}`, dateTimeFormat)
      date = createDateFromString(dt, dateTimeFormat)
    }
    onDateSelect(date)
  }

  const {
    isSelected,
    isSelectedStartOrEnd,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect: overrideDateSelect,
    onDateHover,
    dayRef
  })

  if (!day) {
    return <div />
  }

  return (
    <button
      className={cx(styles.day, {
        [styles.selected]: isSelected || isSelectedStartOrEnd,
        [styles.selectedStartOrEnd]: isSelectedStartOrEnd,
        'day-selected': isSelected || isSelectedStartOrEnd,
        'selected-start-end': isSelectedStartOrEnd
      })}
      role={day}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
      type="button"
      ref={dayRef}
    >
      {day}
    </button>
  )
}

export default Day
